<template>
    <v-container fluid>
        <v-row wrap class="ma-0">
            <v-col cols="12" md="9">
                <v-row v-if="bo">
                    <v-btn x-small class="mt-1 ml-2 white--text" color="green darken-4"
                        :to="{name:'datajournal.edit.bo',params:{id:this.$route.params.journal_id}}" >
                        edit journal
                    </v-btn>
                    <span class="mt-1 ml-2 text-subtitle-2 green--text text--darken-4 font-weight-bold" >
                        To edit the Editorial board, Instructions, Hybrid model and Subscription, click on the corresponding menu item in the navigation menu.
                        This will take you to the appropriate page where you can make changes and updates as needed.
                    </span>
                </v-row>
                <v-row >
                    <v-col v-if="journal" cols="12" lg="4" md="3" class="mb-n1 mb-sm-1 mx-0 text-h6 blue--text text--darken-4 pointer">
                        <router-link :to="{name:getJournalRouteName(), params: { journal_id: $route.params.journal_id, tab: 'home'}}">
                            {{ journal.TITLE }}
                        </router-link>
                        <v-btn v-if="width < 960" rounded large class="ml-1 ml-sm-6 mt-3 mb-n1 text-caption blue--text text--darken-4 nottransform" :color="journal.color">
                            <a :href="journal.system" target="_blanc" class="black--text font-weight-bold">
                                <img :src="require('../../../../assets/library/arrow.png')" >
                                Paper <br/>submission
                                <img :src="require('../../../../assets/library/arrow.png')" >
                            </a>
                        </v-btn>
                    </v-col>
                    <v-col  v-if = "bismenudown == false" cols="12" lg="8"  md="9" class="mx-0 my-0   ml-sm-n3 body-2 blue--text text--darken-4" >
                        <app-bis-menu-journal v-if="this.$route.params.journal_id != 3" :bo="bo" ></app-bis-menu-journal>
                        <app-bis-menu-journal-bohemica v-else :bo="bo"></app-bis-menu-journal-bohemica>
                    </v-col>
                    <v-col v-if = "bismenudown == true"  class="ml-0 mt-0 body-2 blue--text text--darken-4" >
                        <app-main-manu-journal></app-main-manu-journal>
                    </v-col>
                <v-row class="ml-0 mt-n8 mt-sm-0 mb-sm-1">
                    <div v-if="bismenudown == true" class="mx-0 mt-0 body-2 blue--text text--darken-4">
                        <app-bis-menu-journal v-if="this.$route.params.journal_id != 3" :bo="bo"></app-bis-menu-journal>
                        <app-bis-menu-journal-bohemica v-else :bo="bo"></app-bis-menu-journal-bohemica>

                    </div>
                    <div v-if = "bismenudown == false">
                        <app-main-manu-journal :bo="bo"></app-main-manu-journal>
                    </div>
                </v-row>
                </v-row>
                  <v-row v-if="bo" class="mt-3 mb-0">
                    <v-btn x-small class="mt-1 ml-2 white--text" color="blue darken-4"
                        :to="{name:'journaldescription.edit.bo',params:{id:this.$route.params.journal_id}}" >
                        edit description
                    </v-btn>
                </v-row>
                <v-row class="ml-0">
                     <keep-alive :key="this.$route.params.journal_id" class="ml-0">
                        <component v-bind:is="currentTabComponent" :bo="bo"></component>
                    </keep-alive>

                </v-row>
                <v-row>
                    <app-all-issue-footer v-if="currentTabComponent == 'AppAllIssue'" :bo="bo"></app-all-issue-footer>
                </v-row>
            </v-col>
            <v-col v-if="journal" cols="12" md="3" align="center" justify="center">
                <v-btn  v-if="width >= 960" rounded x-large class="ml-0 mr-6 mb-2 text-caption blue--text text--darken-4 nottransform" :color="journal.color">
                    <a :href="journal.system" target="_blanc" class="black--text font-weight-bold">
                    <img :src="require('../../../../assets/library/arrow.png')" >
                    Paper <br/>submission
                    <img :src="require('../../../../assets/library/arrow.png')" >
                    </a>
                </v-btn>
                <app-pattern-journal-right-column :bo="bo"></app-pattern-journal-right-column>
                <p class="ml-3 mb-0 d-flex justify-center"><span class="font-weight-bold">ISSN:&nbsp;</span>{{ journal.ISSNP }}</p>
                <p class="ml-3 mb-0 d-flex justify-center"><span class="font-weight-bold">eISSN:&nbsp;</span>{{ journal.ISSNE }}</p>
                <p v-if="journalBis && journalBis.impactfactor" class="ml-3 mb-0 d-flex justify-center">
                    <a  v-if="journalBis.impactfactorurl" :href="journalBis.impactfactorurl"  target="_blanc">
                        <span class="font-weight-bold" >IF:</span> {{ journalBis.impactfactor }}
                    </a>
                    <span v-else class="font-weight-bold" >IF:</span>
                    <span v-if="!journalBis.impactfactorurl">{{ journalBis.impactfactor }}</span>
                </p>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import homeLibrary from '../../library/HomeLibrary.vue';
import onLineFirstArticle from '../OnLineFirstArticle.vue';
import allIssue from '../AllIssue.vue';
import allIssueFooter from '../AllIssueFooter.vue';
import currentIssue from '../CurrentIssue.vue';
import bisMenuJournal from './BisMenuJournal.vue';
import bisMenuJournalBohemica from './BisMenuJournalBohemica.vue';
import mainMenuJournal from './MainMenuJournal.vue';
import homeJournal from '../HomeJournal.vue';
import editorialBoard from '../EditorialBoard.vue';
import hybridModel from '../HybridPublishingModel.vue';
import subscription from '../Subscription.vue';
import instructions from '../Instructions.vue';
import patternJournalRightColumn from './PatternJournalRightColumn.vue';


import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';

export default {
    name:"patternjournal",
        props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data() {
        return {
            number_to_bo_journal : {
                1 : "am.journal.bo",
                2 : "cmj.journal.bo",
                3 : "mb.journal.bo",
            }
        };
    },
    /**
     * component HomeLibrary.vue in the default component for keep-alive block with dynamic component
     */
    components:{
        'AppHomeLibrary':homeLibrary,
        'AppAllIssue':allIssue,
        'AppAllIssueFooter':allIssueFooter,
        'AppCurrentIssue':currentIssue,
        'AppOnLineArticle':onLineFirstArticle,
        'AppBisMenuJournal':bisMenuJournal,
        'AppBisMenuJournalBohemica':bisMenuJournalBohemica,
        'AppMainManuJournal':mainMenuJournal,
        'AppHomeJournal':homeJournal,
        'AppEditorialBoard':editorialBoard,
        'AppHybridModel':hybridModel,
        'AppSubscription':subscription,
        'AppInstructions':instructions,
        'AppPatternJournalRightColumn':patternJournalRightColumn,
    },
    computed:{
        ...mapGetters('library',{
            currentTabComponent:'currentTabComponent',
            bismenudown:'bismenudown',
            journal:'journal',
            journalBis:'journalBis',
        }),
        ...mapGetters('header',{
            width:'width',
        }),
    },
    methods:{
        ...mapActions('library',{
            setCurrentTabComponent:'setCurrentTabComponent',
            setBismenudown:'setBismenudown',
        }),
        ...mapActions('header',{
            set_width:'set_width',
        }),
        onResize(e) {
            const { scrollWidth, scrollHeight } = e;
            this.set_width(scrollWidth);
        },
        getJournalRouteName() {
            if (this.bo) {
                let journal_name = this.number_to_bo_journal[parseInt(this.$route.params.journal_id)];
                if (journal_name) {
                    return journal_name;
                } else {
                    log.error("Could not translate number " + parseInt(this.$route.params.journal_id) + " into journal name");
                    // this will wrongly move the user to the non-bo page
                    return 'journal'; 
                }
            } else {
                return 'journal';
            }
        }
    }
}
</script>
<style scoped>
.pointer {
    cursor: pointer;
}
</style>

